import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export const useUserActivity = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const trackActivity = async () => {
      const today = new Date().toISOString().split('T')[0];

      // Try to update existing record for today
      const { data: existing } = await supabase
        .from('user_activity')
        .select('id, page_views, actions_count')
        .eq('user_id', user.id)
        .eq('activity_date', today)
        .single();

      if (existing) {
        // Update existing record
        await supabase
          .from('user_activity')
          .update({
            page_views: existing.page_views + 1,
            actions_count: existing.actions_count + 1,
          })
          .eq('id', existing.id);
      } else {
        // Insert new record
        await supabase.from('user_activity').insert({
          user_id: user.id,
          activity_date: today,
          page_views: 1,
          actions_count: 1,
        });
      }
    };

    // Track on mount
    trackActivity();

    // Track every 5 minutes
    const interval = setInterval(trackActivity, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user]);
};
